import React from "react"
import {DefaultProps, RefTable} from "../RefTable";

export const EASOSSIntermediaryNumbers = (props)=><RefTable {...props}/>;

EASOSSIntermediaryNumbers.defaultProps = {
    ...DefaultProps,
    title: "EAS OSS Intermediary Numbers",
    tableSchema: "eas_oss_intermediary_number",
    tableName: "eas_oss_intermediary_number",
    edit: false,
    add: false
}
